<template>
  <custom-dialog width="940px" :title="model.title" class="component-item-dialog" :visible="visible" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body" ref="body">
      <el-form ref="form" :model="form" :rules="rules">
        <div class="ub">
          <div class="ub-f1">
            <div class="form-content">
              <div class="title">
                {{ $t('dms_component_item_dialog.ji_ben_xin_xi') }}
              </div>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.bu_jian_lei_bie')" prop="parentCode">
                    <el-select v-model="form.parentCode" :placeholder="$t('Common.com_please_select')" :disabled="!!parentCode">
                      <el-option v-for="item in classifyList" :key="item.componentCode" :label="item.componentName" :value="item.componentCode"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.bu_jian_bian_hao')" prop="componentCode">
                    <el-input v-model="form.componentCode"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.bu_jian_ming_cheng')" prop="componentName">
                    <el-input v-model="form.componentName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.duo_yu_yan_dai_ma')" prop="langComponentName">
                    <el-input v-model="form.langComponentName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.bu_jian_miao_shu')" prop="componentDesc">
                    <el-input v-model="form.componentDesc"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.bjmsdyy')" prop="langComponentDesc">
                    <el-input v-model="form.langComponentDesc"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <!-- 合成部件 -->
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.he_cheng_bu_jian')">
                    <el-radio v-model="form.isCombined" :label="true" @change="isCombinedChange">{{ $t('Common.com_yes') }}</el-radio>
                    <el-radio v-model="form.isCombined" :label="false" @change="isCombinedChange">{{ $t('Common.com_no') }}</el-radio>
                  </el-form-item>
                </el-col>
                <!-- 固件 -->
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.gu_jian')">
                    <el-radio v-model="form.hasFw" :label="true">{{ $t('Common.com_yes') }}</el-radio>
                    <el-radio v-model="form.hasFw" :label="false">{{ $t('Common.com_no') }}</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 合成编号 -->
              <el-row :gutter="20" v-if="form.isCombined">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.he_cheng_bian_hao')" prop="combineCodes">
                    <!-- <el-input v-model="form.combineCodes"></el-input> -->
                    <el-select v-model="form.combineCodes" multiple filterable remote reserve-keyword :placeholder="$t('dms_component_item_dialog.he_cheng_bian_hao')" :remote-method="getCombineCodesOptions">
                      <el-option v-for="item in combineCodesOptions" :key="item.componentCode" :label="item.componentName" :value="item.componentCode"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.xian_shi_shun_xu')">
                    <el-input v-model="form.showOrder" :min="0" type="number"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('Common.com_status')">
                    <el-radio v-model="form.state" :label="true">{{ $t('Common.com_enable') }}</el-radio>
                    <el-radio v-model="form.state" :label="false">{{ $t('Common.com_disable') }}</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.bu_jian_tu_biao')">
                    <template v-if="form.componentIcon">
                      <div class="component-icon-container">
                        <img :src="getIconUrl(form.componentIcon)" alt="" class="img" />
                        <div class="close-content">
                          <div class="mask"></div>
                          <i class="icon icon-shanchu" @click="clearImg"></i>
                        </div>
                      </div>
                      <el-button class="change-icon" type="primary" @click="showComponentIconDialog">{{ $t('dms_component_item_dialog.geng_huan_tu_biao') }}</el-button>
                    </template>
                    <template v-else>
                      <div class="upload-content" @click="showComponentIconDialog">
                        <i class="el-icon-plus center"></i>
                      </div>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div class="form-content">
              <div class="title">
                {{ $t('dms_component_item_dialog.qi_ta_she_zhi') }}
              </div>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.ce_shi_bao_gao')">
                    <custom-select :multiple="true" v-model="form.needTestTypes" code="iot_need_test_types"></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.shu_ju')">
                    <el-radio v-model="form.hasData" :label="true">{{ $t('dms_component_item_dialog.you') }}</el-radio>
                    <el-radio v-model="form.hasData" :label="false">{{ $t('dms_component_item_dialog.wu') }}</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.bao_yang')">
                    <el-radio v-model="form.isUpkeep" :label="true">{{ $t('dms_component_item_dialog.xu_yao') }}</el-radio>
                    <el-radio v-model="form.isUpkeep" :label="false">{{ $t('dms_component_item_dialog.bu_xu_yao') }}</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div style="width: 1px; background-color: rgb(242, 243, 251); margin: 0px 24px"></div>
          <div class="ub-f1">
            <div class="form-content">
              <div class="title">{{ $t('dms_component_item_dialog.ling_jian_she_zhi') }}</div>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.ling_jian_lei_bie')">
                    <custom-select v-model="form.partClass" code="asm_part_class"></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.geng_huan_deng_ji')">
                    <el-radio v-model="form.needRegister" :label="true">{{ $t('dms_component_item_dialog.xu_yao') }}</el-radio>
                    <el-radio v-model="form.needRegister" :label="false">{{ $t('dms_component_item_dialog.bu_xu_yao') }}</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="form.needRegister">
                <el-col :span="8">
                  <el-form-item :label="$t('dms_component_item_dialog.ling_jian_shu_liang')">
                    <el-input v-model="form.partCount" :min="0" type="number"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item :label="$t('dms_component_item_dialog.bian_ma_lu_ru')">
                    <el-radio v-for="(item, index) in dicArrMap.iot_structure_need_sn" :key="index" v-model="form.needSn" :label="Number(item.value)">{{ item.label }}</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="snSourceVisible">
                <el-col :span="24">
                  <el-form-item :label="$t('dms_component_item_dialog.SNlai_yuan')">
                    <custom-select code="iot_structure_sn_source" v-model="form.snSource"></custom-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="form.needRegister && form.hasData">
                <el-col :span="24">
                  <el-form-item :label="$t('dms_component_item_dialog.ghtbsj')">
                    <custom-select
                      v-if="protocolCode"
                      v-model="form.topicBizCodes"
                      :props="{ label: 'topicName', value: 'topicBizCode' }"
                      :params="{ protocolCode: protocolCode }"
                      url="TopicConfigTopicList"
                      :multiple="true"
                    ></custom-select>
                    <!-- <btn-select
                      :data="topicConfigTopicList"
                      v-model="form.topicBizCodes"
                      :props="{label: 'topicName', value: 'topicBizCode'}"
                      :multiple="true"
                    ></btn-select> -->
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div class="form-content">
              <div class="title">{{ $t('dms_component_item_dialog.bu_jian_shou_ming') }}</div>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.shou_ming')">
                    <el-radio v-model="form.isLifeLimit" :label="true">{{ $t('Common.com_yes') }}</el-radio>
                    <el-radio v-model="form.isLifeLimit" :label="false">{{ $t('Common.com_no') }}</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="form.isLifeLimit" :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.zui_da_zhi')">
                    <el-input v-model="form.maxVal" type="number" :min="0"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.lin_jie_zhi')" prop="criticalVal">
                    <el-input v-model="form.criticalVal" type="number" :min="0"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col v-if="form.isLifeLimit" :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.dan_wei')">
                    <custom-select v-model="form.currentUnit" code="iot_tsl_data_unit" width="100%"></custom-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div class="form-content">
              <div class="title">{{ $t('dms_component_item_dialog.shi_shi_zhuang_tai') }}</div>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.dan_wei')" prop="statusUnit">
                    <custom-select v-model="form.statusUnit" code="iot_tsl_data_unit" width="100%"></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('dms_component_item_dialog.zhuang_tai_zi_dian')">
                    <el-input v-model="form.statusDicGroup"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('Common.com_cancel') }}
      </el-button>
      <el-button type="primary" @click="onConfirm">
        {{ $t('Common.com_confirm') }}
      </el-button>
    </div>
    <component-icon-dialog v-if="componentIconDialogVisible" @close="componentIconDialogVisible = false" :model="componentIconDialogModel" @confirm="componentIconConfirm"></component-icon-dialog>
  </custom-dialog>
</template>

<script>
/** 部件编辑/新增 组件 */

import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import componentIconDialog from './component_icon_dialog';
// import btnSelect from './btn_select';

export default {
  mixins: [dialogMixins],
  components: {
    // iconSelect,
    componentIconDialog,
    // btnSelect
  },
  props: {
    // 必填
    protocolCode: String,
    classifyList: {
      type: Array,
      default() {
        return [];
      },
    },
    parentCode: [String, Number],
  },
  data() {
    return {
      stateArr: [],
      boolArr: [],
      form: {
        /** 基本信息 start */
        // 部件分类
        parentCode: '',
        // 部件名称
        componentName: '',
        // 部件编号
        componentCode: '',
        // 部件图标
        componentIcon: '',
        // 多语言代码
        langComponentName: '',
        // 部件描述
        componentDesc: '',
        // 部件描述多语言
        langComponentDesc: '',
        // 是否登记
        needRegister: false,
        // 编码登记d
        needSn: 0,
        // 状态
        state: true,
        // 设备测试显示 =》 测试报告 isTestShow =》 needTestTypes
        needTestTypes: '',
        // 排序顺序
        showOrder: 0,

        // 是否有数据
        hasData: true,
        // 部件是否有寿命上限
        isLifeLimit: false,
        // 是否需要保养
        isUpkeep: false,
        // 组件需要绑定多少个零件
        partCount: 0,
        // 固件
        hasFw: false,
        // 单位
        currentUnit: '',
        // 最大值
        maxVal: '',
        // 临界值
        criticalVal: '',
        // 单位
        statusUnit: '',
        // 状态字典
        statusDicGroup: '',
        /** 状态信息 end */

        // 零件设置
        partClass: '',

        // sn来源
        snSource: '',

        topicBizCodes: [],

        isCombined: false,

        combineCodes: [],
      },

      combineCodesOptions: [],

      topicConfigTopicList: [],
      componentIconDialogVisible: false,
      componentIconDialogModel: {},
      iconList: [],
      bizType: 'iot.component.icon',
      iconAttach: null,
    };
  },
  computed: {
    rules() {
      return {
        /** 基本信息 start */
        parentCode: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        componentName: [
          {
            max: 50,
            message: this.$t('Common.com_rules_length_max', [50]),
          },
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        componentCode: [
          {
            max: 30,
            message: this.$t('Common.com_rules_length_max', [30]),
          },
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        langComponentName: [
          {
            max: 100,
            message: this.$t('Common.com_rules_length_max', [100]),
          },
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        componentDesc: {
          max: 200,
          message: this.$t('Common.com_rules_length_max', [200]),
        },
        langComponentDesc: {
          max: 50,
          message: this.$t('Common.com_rules_length_max', [200]),
        },
      };
    },
    // 是否显示-SN来源
    snSourceVisible() {
      return this.form.needRegister && this.dicMap.iot_structure_need_sn && `${this.form.needSn}` !== `${this.dicMap.iot_structure_need_sn.no}`;
    },
    combineCodesUrl() {
      if (this.protocolCode) {
        return `${apis.ComponentCombineSelect}/${this.protocolCode}`;
      }
      return '';
      // protocolCode
    },
  },
  mounted() {
    this.getOssConfig();
    this.getIconList();
    this.getTopicBizCodeData();
    this.getCombineCodesOptions();
    // this.getConfigTopicList();
    this.getDictionary('cloud_common_state,isynergy_cloud_bool', (dictionary) => {
      this.stateArr = dictionary.cloud_common_state;
      this.boolArr = dictionary.isynergy_cloud_bool;
    });
    this.getDicArrMap('iot_structure_need_sn,asm_part_class', () => {
      this.getDicMap('iot_structure_need_sn', () => {
        this.init();
      });
    });
  },
  methods: {
    isCombinedChange() {
      // 合成部件为否时，隐藏合成编号，清除掉合成编号数据
      const { isCombined } = this.form;
      if (!isCombined) {
        this.form.combineCodes = '';
      }
    },
    clearImg() {
      this.iconAttach = '';
      this.form.componentIcon = '';
    },
    getCombineCodesOptions(keyword = '') {
      const url = this.combineCodesUrl;
      const query = {
        keyword,
      };
      this.$getJSON(url, query).then((res) => {
        this.combineCodesOptions = res.data;
      });
    },
    // 获取oss配置
    getOssConfig: function () {
      const folder = this.$getUploadFolder(this.bizType);
      this.$getJSON(apis.ossUpload, { folder }).then((res) => {
        this.ossConfig = res.data;
      });
    },
    // 获取配置服务topic
    // getConfigTopicList() {
    //   const reqData = {
    //     protocolCode: this.protocolCode
    //   };
    //   return this.$getJSON(apis.TopicConfigTopicList, reqData).then((res) => {
    //     this.configTopicList = res.data;
    //   });
    // },
    // 获取 更换同步数据下拉数据
    getTopicBizCodeData() {
      this.$getJSON(apis.TopicConfigTopicList, {
        protocolCode: this.protocolCode,
      }).then((res) => {
        this.topicConfigTopicList = res.data;
      });
    },
    getIconUrl(attachId) {
      const item = this.iconList.find((obj) => obj.bizId === attachId);
      if (item) {
        return this.getAttachUrl(item);
      }
      return '';
    },
    addIcon(item) {
      if (!this.iconList.some((obj) => obj.bizId === item.attachId)) {
        this.iconList.push(item);
      }
    },
    componentIconConfirm(data) {
      this.form.componentIcon = data.attachId;
      this.addIcon(data);
      this.initIconAttach();
    },
    initIconAttach() {
      const componentIcon = this.form.componentIcon;
      if (componentIcon) {
        const item = this.iconList.find((obj) => obj.bizId === componentIcon);
        if (item) {
          this.iconAttach = item;
        }
      }
    },
    getIconList() {
      this.$getJSON(apis.ComponentIconList, {}).then((res) => {
        const iconIds = res.data;
        this.$getAttachFileListType(iconIds, 'iot.component.icon').then((list) => {
          list.forEach((item) => {
            item.bizType = this.bizType;
          });
          this.iconList = list;
          this.initIconAttach();
        });
      });
    },
    showComponentIconDialog() {
      this.componentIconDialogModel = {
        title: this.$t('dms_component_item_dialog.bu_jian_tu_biao'),
      };
      this.componentIconDialogVisible = true;
    },
    listFilter(list, keys) {
      return list.filter((item) => keys.includes(`${item.value}`));
    },
    fixBody() {
      setTimeout(() => {
        this.$refs.body.scrollTop = 0;
      }, 100);
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.$refs.form.validate((val) => {
        // if (!this.form.componentIcon) {
        //   return this.$message.error('部件图标必填');
        // }
        if (val) {
          if (this.model.type === 'add') {
            this.create();
          } else {
            this.edit();
          }
        }
        return null;
      });
    },
    create() {
      return this.$postJSON(apis.ComponentSave, this.getCreateReqData()).then((data) => {
        this.closeDialog();
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success', {
          data,
          type: 'add',
        });
      });
    },
    edit() {
      return this.$postJSON(apis.ComponentSave, this.getEditReqData()).then((data) => {
        this.closeDialog();
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success', {
          data,
          type: 'edit',
        });
      });
    },
    getCreateReqData() {
      const iconAttach = {
        ...this.iconAttach,
        attachPath: this.$formatAttachPath(this.iconAttach ? this.iconAttach.attachPath : ''),
        attachName: this.$formatAttachName(this.iconAttach ? this.iconAttach.attachPath : ''),
      };
      const ret = {
        ...this.form,
        protocolCode: this.protocolCode,
        iconAttach: iconAttach,
      };

      if (!ret.iconAttach || !ret.iconAttach.attachPath) {
        ret.iconAttach = null;
      }

      ret.topicBizCodes = (ret.topicBizCodes || []).join(',');

      if (this.form.combineCodes && this.form.combineCodes.length) {
        ret.combineCodes = this.form.combineCodes.join(',');
      } else {
        ret.combineCodes = '';
      }

      if (this.form.needTestTypes && this.form.needTestTypes.length) {
        ret.needTestTypes = this.form.needTestTypes.join(',');
      } else {
        ret.needTestTypes = '';
      }

      // 不需要更换登记不显示  partCount  needSn
      if (!this.form.needRegister) {
        ret.partCount = '';
        ret.needSn = '';
      }
      if (!this.form.isLifeLimit) {
        // 寿命禁用时不显示  maxVal  criticalVal
        ret.maxVal = '';
        ret.criticalVal = '';

        // 寿命禁用时不显示 currentUnit
        ret.currentUnit = '';
      }

      // needRegister && hasData 才显示 更换同步数据-topicBizCodes
      if (!this.form.needRegister || !this.form.hasData) {
        ret.topicBizCodes = '';
      }

      // 后端的需求，当partClass不选时，传0
      if (!this.form.partClass) {
        ret.partClass = 0;
      }

      ret.maxVal = this.form.maxVal ? Number(this.form.maxVal) : '';
      ret.criticalVal = this.form.criticalVal ? Number(this.form.criticalVal) : '';
      return ret;
    },
    getEditReqData() {
      return {
        ...this.getCreateReqData(),
        componentId: this.model.data.componentId,
      };
    },
    init() {
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.data);
        this.form.needSn = this.form.needSn ? Number(this.form.needSn) : this.form.needSn;
        this.form.showOrder = this.form.showOrder || 0;
        this.form.partCount = this.form.partCount || 0;
        if (this.form.needTestTypes && !Array.isArray(this.form.needTestTypes)) {
          this.form.needTestTypes = this.form.needTestTypes.split(',');
        }
        // this.form.theoryUseTime = this.form.theoryUseTime || 0;
        // 零件类别（普通/重大/耗材，不选默认无）(实时就是为了清除后端淘汰的字典值)
        if (this.form.partClass !== undefined && !this.dicArrMap.asm_part_class.some((item) => `${item.value}` === `${this.form.partClass}`)) {
          this.form.partClass = '';
        }

        if (this.form.topicBizCodes && typeof this.form.topicBizCodes === 'string') {
          this.form.topicBizCodes = this.form.topicBizCodes.split(',');
        }
        if (this.form.combineCodes && typeof this.form.combineCodes === 'string') {
          this.form.combineCodes = this.form.combineCodes.split(',');
        }
      } else {
        this.form.parentCode = this.parentCode;
      }
      this.fixBody();
    },
  },
};
</script>

<style lang="scss">
.component-item-dialog {
  .el-form-item__label {
    text-align: left;
    width: 100% !important;
  }

  .dialog-body {
    height: 500px;
    overflow-y: auto;
  }

  .el-select {
    width: 100%;
  }

  .form-content {
    &:nth-child(n + 2) {
      margin-top: 15px;
    }
    .title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 18px;
      color: #35405b;
    }
  }
  $itemR: 100px;
  .upload-content {
    width: $itemR;
    height: $itemR;
    border: 1px dashed #c0ccda;
    position: relative;
    color: #8c939d;
    font-size: 28px;
    cursor: pointer;
    overflow: hidden;
  }

  .change-icon {
    margin-top: 15px;
  }

  .component-icon-container {
    width: 100px;
    height: 100px;
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.3);
    cursor: pointer;

    &:hover {
      .close-content {
        display: block;
      }
    }

    .img {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      max-width: 95%;
      max-height: 95%;
      z-index: 0;
    }

    .close-content {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 10;
      display: none;
      .mask {
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.3;
      }
      .icon {
        font-size: 16px;
        position: absolute;
        z-index: 10;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        color: #fff;
      }
    }
  }
}
</style>
